export default {
    methods: {
        print() {
            return {
                agendamento(agendamento) {

                    const page = window.open('', Math.random())

                    const date = new Date().toLocaleString();

                    const image = page.document.createElement('img')

                    image.style.height = '30px';

                    image.src = agendamento.logotipo ? require(`@/assets/cliente/logotipo/${agendamento.logotipo}`) : null

                    let urgente = agendamento.urgente ?
                        `<p><strong>PEDIDO COM URGÊNCIA</strong></p><p class="line"></p>` : ''

                    let prefeitura = agendamento.nomePrefeitura ? `
                        <strong>PREFEITURA DE ${agendamento.nomePrefeitura}</strong>
                        ` : ''

                    let ramoAtividade = agendamento.ramoAtividade ? `Secretaria Municipal de ${agendamento.ramoAtividade}` : ''

                    let sistemaNome = agendamento.sistemaNome ? `${agendamento.sistemaNome}` : ''
                    let sistemaVersao = agendamento.sistemaVersao ? `${agendamento.sistemaVersao}` : ''
                    let responsavel = agendamento.nomeResponsavel ?
                        ` <strong>Responsável:</strong><br />${agendamento.nomeResponsavel}` : ''

                    let observacao = '';

                    if (agendamento.observacao) {
                        observacao = `
                            <tr>
                                <td class="report-content-cell">
                                    <div id="obsAgendamento">
                                        <fieldset>
                                            <legend style="font-size:14px;"><b>Observação do agendamento</b></legend>
                                            <p style="font-size: 13px">${agendamento.observacao}</p>
                                        </fieldset>
                                    </div>
                                </td>
                            </tr>
                        `;
                    }

                    let regulacaoMensagemComprovanteAgendamento = '';

                    if (agendamento.regulacaoMensagemComprovanteAgendamento) {
                        regulacaoMensagemComprovanteAgendamento = `
                            <tr>
                                <td class="report-content-cell">
                                    <div id="compReg">
                                        <fieldset>
                                            <p style="font-size: 13px">${agendamento.regulacaoMensagemComprovanteAgendamento}</p>
                                        </fieldset>
                                    </div>
                                </td>
                            </tr>
                        `;
                    }

                    let table = '<table>'

                    table = table + `
                        <thead>
                            <tr>
                                <th colspan="3" style="border-bottom: 1px solid #000000; padding: 7px; font-size: 16px;">
                                    EXAMES SOLICITADOS
                                </th>
                            </tr>
                        </thead>
                    `
                    table = table + `
                        <thead style="text-align: -webkit-left;">
                            <tr>
                                <th style="font-size: 14px;">Código</th>
                                <th style="font-size: 14px;">Nome</th>
                                <th style="font-size: 14px;">Grupo</th>
                            </tr>
                        </thead>
                    `

                    table = table + `
                        <tr>
                            <td colspan="3" style="border-bottom:1px solid #000000"></td>
                        </tr>
                    `

                    agendamento.examesIncluido.forEach(exame => {

                        table = table + `
                            <tr>
                                <td class="pr-10" style="font-size: 14px;">${exame.codigo ?? ''}</td>
                                <td class="pr-10" style="font-size: 14px;">${exame.nome ?? ''}</td>
                                <td class="pr-10" style="font-size: 14px;">${agendamento.grupoExameNome ?? ''}</td>
                            </tr>
                        `
                        if (exame.observacao) {
                            table = table + `
                                <tr>
                                    <td colspan="3"><strong>Preparo:</strong> ${exame.observacao}</td>
                                </tr>
                            `
                        }

                        table = table + `
                            <tr>
                                <td colspan="3" style="border-bottom:1px dotted #dbdbdb"></td>
                            </tr>
                        `
                    })

                    table.concat(`</table>`)

                    page.document.write(`
                         <head>
                            <title>Pedido do Agendamento</title>

                            <style>
                                * {
                                    font-family: 'Arial', Gadget, sans-serif;
                                }
                                body {
                                    max-width: max-content;
                                    margin: auto;
                                }
                                table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                table {
                                    width: 10.3cm;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 10.3cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    border: 1px solid #000000;
                                }
                                #paciente {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #pedido {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #obs, #compReg {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    margin-bottom: 10px;
                                }
                                #obsAgendamento {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    margin-bottom: 10px;
                                }
                                #left-col {
                                    flex-grow: 1;
                                }
                                #right-col {
                                    flex-grow: 1;
                                    font-size: 0.3cm;
                                    text-align: right;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.25cm;
                                    margin: 0;
                                    padding: 0.05cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 0.35cm;
                                    margin: 0.05cm 0;
                                    padding: 0;
                                }
                                .line {
                                   border-bottom: 1px dotted #c7c7c7;
                                   margin: 5px 0
                                }
                                .lineBottom {
                                   border-bottom: 2px solid #000000;
                                }
                                .pr-10 {
                                   padding-right: 10px;
                                }
                                fieldset{
                                    width: 100%;
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    padding: 0 5px;
                                }
                                legend {
                                    font-family: Arial, Helvetica, sans-serif;
                                    font-size: 15px;
                                    font-weight: 100!important;
                                }
                                #codagendamento {
                                    border: 1px solid #000000;
                                    padding: 5px;
                                    margin-top: 5px;
                                    font-size: 12px;
                                    font-weight: 500;
                                    text-align: -webkit-center;
                                }
                                #data {
                                    border: 1px solid #000000;
                                    width: 50%;
                                    float: left;
                                    margin-top: 10px;
                                    padding: 5px 0 3px 0;
                                    text-align: -webkit-center;
                                    font-size: 12px;
                                    min-height: 35px;
                                }
                                #horario {
                                    border: 1px solid #000000;
                                    width: 45%;
                                    float: left;
                                    margin-top: 10px;
                                    margin-left: 2.5%;
                                    padding: 5px 0 3px 0;
                                    text-align: -webkit-center;
                                    font-size: 12px;
                                    min-height: 35px;
                                }
                                #entrega {
                                    border: 1px solid #000000;
                                    width: 31%;
                                    float: left;
                                    margin-top: 10px;
                                    margin-left: 2.5%;
                                    padding: 5px 0 3px 0;
                                    text-align: -webkit-center;
                                    font-size: 12px;
                                    min-height: 35px;
                                }
                                #rodape-left {
                                    width: 25%;
                                    float: left;
                                    margin-top: 5px;
                                    font-size: 9px;
                                    text-align: left;
                                }
                                #rodape-right {
                                    width: 75%;
                                    float: right;
                                    margin-top: 5px;
                                    font-size: 9px;
                                    text-align: right;
                                }
                                table {
                                    width: 100%;
                                }
                                tr {
                                    border: 1px solid black;
                                    border-collapse: collapse;
                                }
                                td {
                                    font-size: 13px;
                                }
                                #img {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                                #prefeitura {
                                   text-align: center;
                                   padding-top: 5px;
                                   text-transform: uppercase;
                                }
                                #ramoAtividade {
                                    text-align: center;
                                    padding-bottom: 10px;
                                }
                                #prontuario {
                                    float: left;
                                    width: 30%;
                                }
                                #dataNascimento {
                                    padding-left: 5%;
                                    float: left;
                                    width: 63%;
                                }
                                #responsavel {
                                    clear: both;
                                    width: 100%;
                                }
                                .titulo {
                                    font-size: 16px;
                                    text-align: center;
                                    padding: 10px 0 3px 0;
                                }
                                .b-0 {
                                    border: 0;
                                }
                                #agendamentoSpan {
                                    font-size: 18px;
                                    text-align: center;
                                    font-weight: 700;
                                }
                            </style>
                        </head>

                        <body>

                            <table class="report-container">
                                <thead class="report-header">
                                    <tr class="b-0">
                                        <th class="report-header-cell">
                                            <div class="header-info">

                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tfoot class="report-footer">
                                    <tr class="b-0">
                                        <td class="report-footer-cell">
                                            <div class="footer-info">

                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>

                                <tbody class="report-content">
                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="img"></div>
                                            <div id="prefeitura"></div>
                                            <p id="ramoAtividade"></p>
                                            <div class="lineBottom"></div>
                                            <div class="titulo"><strong>DADOS DO AGENDAMENTO</strong></div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="paciente">
                                                <fieldset>
                                                    <legend>Dados do paciente</legend>
                                                    <div id="left-col">
                                                        <p>
                                                            <strong>Paciente:</strong><br />
                                                            ${agendamento.pacienteNome}
                                                        </p>
                                                        <p id="prontuario">
                                                            <strong>Prontuário:</strong><br />
                                                            ${agendamento.prontuario}
                                                        </p>
                                                        <p id="dataNascimento">
                                                            <strong>Data nascimento:</strong><br />
                                                            ${agendamento.dataNascimento}
                                                        </p>
                                                        <p id="responsavel"></p>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="pedido">
                                                <fieldset style="margin:5px 0">
                                                    <legend>Dados do pedido</legend>
                                                    <div id="left-col">

                                                        <div id="urgente"></div>

                                                        <p><strong>Unidade solicitante:</strong></p>
                                                        <p>${agendamento.unidadeSolicitante}</p>
                                                        <p class="line"></p>

                                                        <p><strong>Profissional solicitante:</strong></p>
                                                        <p>${agendamento.medicoNome}</p>
                                                        <p class="line"></p>

                                                        <p><strong>Unidade executante:</strong></p>
                                                        <p>${agendamento.unidadeExecutante}</p>
                                                        <p><strong>Endereços:</strong></p>
                                                        <p>
                                                            ${agendamento.enderecoExecutante},
                                                            ${agendamento.numeroEnderecoExecutante ?? ''} -
                                                            ${agendamento.bairroExecutante} /
                                                            ${agendamento.telefoneExecutante}
                                                        </p>

                                                        <p class="line"></p>
                                                        <p><strong>Profissional executante:</strong></p>
                                                        <p>${agendamento.profissionalNome} </p>
                                                        <p class="line"></p>

                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="codagendamento">
                                                <strong>CÓDIGO DO AGENDAMENTO:</strong>
                                                <span id="agendamentoSpan">${agendamento.agendamentoNumero}</span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">

                                            <div>
                                                <div id="data">
                                                    <strong>DATA:</strong><br />
                                                    <span id="agendamentoSpan">${agendamento.data}</span>
                                                </div>
                                                <div id="horario">
                                                    <strong>HORÁRIO:</strong><br />
                                                    <span id="agendamentoSpan">${agendamento.horaExame}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell" id="table"></td>
                                    </tr>

                                    ${observacao}

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="obs">
                                                <fieldset>
                                                    <legend style="font-size:14px;"><b>Observação</b></legend>
                                                    <p style="font-size: 13px">${agendamento.mensagemProtocolo}</p>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>

                                    ${regulacaoMensagemComprovanteAgendamento}

                                    <tr>
                                        <td class="report-content-cell">
                                            <div class="lineBottom"></div>

                                            <div>
                                                <div id="rodape-left">
                                                    <span id="sistemaNome"></span>
                                                    <span id="sistemaVersao"></span>
                                                </div>
                                                <div id="rodape-right">
                                                    <span>Impresso por: ${agendamento.usuario}</span><br/>
                                                    <span>Data/hora da impressão: ${date}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </body>
                    `)

                    page.document.getElementById('img').appendChild(image)
                    page.document.getElementById('table').innerHTML = table
                    page.document.getElementById('urgente').innerHTML = urgente
                    page.document.getElementById('prefeitura').innerHTML = prefeitura
                    page.document.getElementById('ramoAtividade').innerHTML = ramoAtividade
                    page.document.getElementById('sistemaNome').innerHTML = sistemaNome
                    page.document.getElementById('sistemaVersao').innerHTML = sistemaVersao
                    page.document.getElementById('responsavel').innerHTML = responsavel

                    image.onload = function () {

                        page.print()
                        page.close()
                    }
                },

                etiqueta(etiqueta) {

                    const page = window.open('', Math.random())

                    var nomeExames = ''

                    etiqueta.examesIncluido.forEach(exame => {

                        if (!nomeExames) {

                            nomeExames = exame.nome
                        } else {

                            nomeExames = nomeExames + ', ' + exame.nome
                        }

                    })

                    page.document.write(`
                        <head>
                            <title>Etiqueta</title>

                            <style>
                                * {
                                    font-family: 'Arial', 'Arial Bold', Gadget, sans-serif;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 8.3cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #left-col {
                                    flex-grow: 1;
                                    padding-top:5px;
                                }
                                #right-col {
                                    flex-grow: 1;
                                    font-size: 0.3cm;
                                    text-align: right;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.25cm;
                                    margin: 0;
                                    padding: 0.25cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 0.25cm;
                                    margin: 0.08cm 0;
                                    padding: 0;
                                }
                            </style>
                        </head>

                        <body>
                            <div class="content">
                                <div class="paper">
                                    <h1>${etiqueta.pacienteNome}</h1>

                                    <div class="container">
                                        <div id="header">
                                            <div id="left-col">
                                                <p><strong>DATA NASCIMENTO:</strong> ${etiqueta.dataNascimento}</p>
                                                <p><strong>NR. AGENDAMENTO:</strong> ${etiqueta.agendamentoNumero}</p>
                                                <p><strong>MÉDICO:</strong> ${etiqueta.medicoNome}</p>
                                                <p><strong>UNIDADE:</strong> ${etiqueta.unidadeNome}</p>
                                                <p><strong>DATA EXAME:</strong> ${etiqueta.data}</p>
                                                <p><strong>EXAMES:</strong> ${nomeExames}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </body>
                    `)

                    page.print()
                    page.close()
                },
            }
        }
    },
}